/**
 * Modo muestra del Informe Anual de Autogestión del PESV (issue #1187). SOLO PARA DESARROLLO.
 *
 * Se activa con `VUE_APP_INFORME_PESV_MUESTRA=true` en `.env.development.local` (ignorado por git) y
 * `npm run serve`. Con el modo activo:
 *  - la ruta no exige espacio seleccionado ni el privilegio seguridadVial.informeAutogestion;
 *  - la vista usa un espacio de trabajo ficticio (./muestra/fuenteMuestra.js) y no lee ni escribe Firestore:
 *    ni los registros del espacio seleccionado, ni el registro de informes del RF-12.
 *
 * En un build de producción NODE_ENV es "production" y la constante siempre es false, aunque la variable exista.
 * Los datos ficticios se cargan con import dinámico: su fragmento nunca se solicita fuera del modo.
 */
export const MODO_MUESTRA = process.env.NODE_ENV === "development" && process.env.VUE_APP_INFORME_PESV_MUESTRA === "true";
